/* __next_internal_client_entry_do_not_use__ VerticalLine auto */ import { Core } from "@faire/design-tokens";
import { Color } from "@faire/web--source/slate/Color";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "@faire/web--source/slate/utils/highVisSlateComponent";
import styled, { css } from "styled-components";
/**
 * @trackcomponent
 */ export var VerticalLine = styled.div.withConfig({
    componentId: "sc-8218012f-0"
})([
    "height:",
    ";",
    ";",
    ";background:",
    ";flex-shrink:0;",
    ""
], function(props) {
    var _props_$height;
    return (_props_$height = props.$height) !== null && _props_$height !== void 0 ? _props_$height : "100%";
}, function(props) {
    var _props_$margin;
    return props.$skipMargin ? "" : css([
        "margin:",
        ";"
    ], (_props_$margin = props.$margin) !== null && _props_$margin !== void 0 ? _props_$margin : "0");
}, function(props) {
    var _props_$stroke;
    return css([
        "width:",
        ";"
    ], (_props_$stroke = props.$stroke) !== null && _props_$stroke !== void 0 ? _props_$stroke : "1px");
}, function(param) {
    var $color = param.$color;
    var _Color_$color;
    return(// @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    $color ? (_Color_$color = Color[$color]) !== null && _Color_$color !== void 0 ? _Color_$color : $color : Core.surface.subdued);
}, highVisSlateComponent(HIGH_VIS_FILTER.LAYOUT));
